import * as React from 'react';

export enum SvgIcons
{
    close = 'close',
    search = 'search',
    favorite = 'favorite',
    recent = 'recent',
    font = 'font',
    allItems = 'allItems',
    postPlus = 'postPlus',
    moreHorizontal = 'moreHorizontal',
    fullscreen = 'fullscreen',
    fullscreenExit = 'fullscreenExit',
    photo = 'photo',
    wallpaper = 'wallpaper',
    publish = 'publish',
    arrowRight = 'arrowRight',
    check = 'check'
}

export const Icons:Map<SvgIcons, (props:any) => JSX.Element> = new Map([
    [
        SvgIcons.font,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path
                    d="M17,8H20V20H21V21H17V20H18V17H14L12.5,20H14V21H10V20H11L17,8M18,9L14.5,16H18V9M5,3H10C11.11,3 12,3.89 12,5V16H9V11H6V16H3V5C3,3.89 3.89,3 5,3M6,5V9H9V5H6Z"
                />
            </svg>
        )
    ],
    [
        SvgIcons.close,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path
                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                />
            </svg>
        )
    ],
    [
        SvgIcons.search,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path
                    d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                />
            </svg>
        )
    ],
    [
        SvgIcons.favorite,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
            </svg>
        )
    ],
    [
        SvgIcons.recent,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path
                    d="M13 3a9 9 0 00-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0013 21a9 9 0 000-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
            </svg>
        )
    ],
    [
        SvgIcons.allItems,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path d="M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z" />
            </svg>
        )
    ],
    [
        SvgIcons.postPlus,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path d="M17 19.22H5V7h7V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h-2v7.22z" />
                <path
                    d="M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM7 9h8v2H7zM7 12v2h8v-2h-3zM7 15h8v2H7z" />
            </svg>
        )
    ],
    [
        SvgIcons.moreHorizontal,
        props => (
            <svg
                viewBox="0 0 24 24"
                {...props}
            >
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
            </svg>
        )
    ],
    [
        SvgIcons.fullscreen,
        props => (
            <svg
                viewBox="0 0 24 24"
                {...props}
            >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" />
            </svg>
        )
    ],
    [
        SvgIcons.fullscreenExit,
        props => (
            <svg
                viewBox="0 0 24 24"
                {...props}
            >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z" />
            </svg>
        )
    ],
    [
        SvgIcons.photo,
        props => (
            <svg
                viewBox="0 0 24 24"
                {...props}
            >
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
            </svg>
        )
    ],
    [
        SvgIcons.wallpaper,
        props => (
            <svg
                viewBox="0 0 24 24"
                {...props}
            >
                <path
                    d="M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z" />
                <path d="M0 0h24v24H0z" fill="none" />
            </svg>
        )
    ],
    [
        SvgIcons.publish,
        props => (
            <svg
                viewBox="0 0 24 24"
                {...props}
            >
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z" />
            </svg>
        )
    ],
    [
        SvgIcons.arrowRight,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path d='M10 17l5-5-5-5v10z' />
                <path fill='none' d='M0 24V0h24v24H0z' />
            </svg>
        )
    ],
    [
        SvgIcons.check,
        props => (
            <svg
                viewBox='0 0 24 24'
                {...props}
            >
                <path fill='none' d='M0 0h24v24H0z' />
                <path d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' />
            </svg>
        )
    ]
]);
